import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Facebook } from 'lucide-react';

const Footer = () => {
  const footerLinks = {
    Company: [
      { name: 'About Us', href: '/about' },
      { name: 'Our Story', href: '/about' },
      { name: 'Careers', href: '#' },
      { name: 'Press', href: '#' }
    ],
    Support: [
      { name: 'Contact', href: '/contact' },
      { name: 'Size Guide', href: '#' },
      { name: 'Shipping', href: '#' },
      { name: 'Returns', href: '#' }
    ],
    Community: [
      { name: 'Blog', href: '/blog' },
      { name: 'Testimonials', href: '/testimonials' },
      { name: 'Ambassador Program', href: '#' },
      { name: 'Events', href: '#' }
    ]
  };

  return (
    <footer className="bg-black border-t border-lime-400/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-12 sm:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-8">
            {/* Brand Section */}
            <div className="lg:col-span-5">
              <Link to="/" className="inline-block mb-6">
                <img 
                  src="/PBX Pickle Strike Vector Artwork.png" 
                  alt="PBX Pickle Logo" 
                  className="h-10 sm:h-12 w-auto"
                />
              </Link>
              
              <p className="text-gray-300 text-base sm:text-lg leading-relaxed mb-6 max-w-md">
                Adaptive pickleball apparel that champions every athlete. 
                Move Different. Play Bold.
              </p>

              {/* Newsletter Signup */}
              <div className="mb-6">
                <h3 className="text-white font-bold mb-3">Stay in the Game</h3>
                <div className="flex flex-col sm:flex-row max-w-md w-full">
                  <input 
                    type="email" 
                    placeholder="Enter your email"
                    className="flex-1 px-4 py-3 rounded-lg sm:rounded-l-lg sm:rounded-r-none bg-gray-800 text-white border border-gray-700 focus:border-lime-400 focus:outline-none mb-2 sm:mb-0 min-w-0"
                  />
                  <button className="bg-lime-400 text-black px-6 py-3 rounded-lg sm:rounded-l-none sm:rounded-r-lg font-bold hover:bg-lime-300 transition-colors whitespace-nowrap">
                    Subscribe
                  </button>
                </div>
              </div>

              {/* Social Links */}
              <div className="flex space-x-4">
                <a 
                  href="https://www.instagram.com/pbxpickle/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-lime-400 transition-colors"
                  aria-label="Follow us on Instagram"
                >
                  <Instagram className="w-6 h-6" />
                </a>
                <a 
                  href="https://www.linkedin.com/in/felixbirman1/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-lime-400 transition-colors"
                  aria-label="Connect with us on LinkedIn"
                >
                  <Linkedin className="w-6 h-6" />
                </a>
                <a 
                  href="https://www.facebook.com/Liquidglasslabs/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-lime-400 transition-colors"
                  aria-label="Follow us on Facebook"
                >
                  <Facebook className="w-6 h-6" />
                </a>
              </div>
            </div>

            {/* Links Sections */}
            <div className="lg:col-span-7 grid sm:grid-cols-3 gap-8">
              {Object.entries(footerLinks).map(([category, links]) => (
                <div key={category}>
                  <h3 className="text-white font-bold mb-4 tracking-wide">{category}</h3>
                  <ul className="space-y-3">
                    {links.map((link) => (
                      <li key={link.name}>
                        <Link 
                          to={link.href} 
                          className="text-gray-400 hover:text-lime-400 transition-colors"
                        >
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 PBX Pickle. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="#" className="text-gray-400 hover:text-lime-400 text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="#" className="text-gray-400 hover:text-lime-400 text-sm transition-colors">
                Terms of Service
              </Link>
              <Link to="#" className="text-gray-400 hover:text-lime-400 text-sm transition-colors">
                Accessibility
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
